export default __webpack_public_path__ + "images/failed_practice_exam.d0942e2e309272fa957fe7e11744eb68.svg";